import { render, staticRenderFns } from "./bimFooter.vue?vue&type=template&id=fd6839ae&scoped=true&lang=html&"
import script from "./bimFooter.vue?vue&type=script&lang=js&"
export * from "./bimFooter.vue?vue&type=script&lang=js&"
import style0 from "./bimFooter.vue?vue&type=style&index=0&id=fd6839ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6839ae",
  null
  
)

export default component.exports